module.exports = __webpack_public_path__ + "img/play-icon.2c50723a.png";